import 'babel-polyfill'
import 'whatwg-fetch'

import './../static/css/index.css'
import './../static/images/favicon.png'
import './../static/images/favicon512.png'

import React from 'react'
import ReactDOM from 'react-dom'
import {
  Redirect,
  BrowserRouter as Router,
  Route,
  Switch
} from 'react-router-dom'
import Polyglot from 'node-polyglot'
import Loadable from 'react-loadable'

import ArrowUp from './../static/images/arrow_up_bold_stroke.svg'

import Auth from './auth'
import ErrorPage from './error-page'
import Footer from './footer'
import Header from './header'
import LocaleEl from './../i18n/locale-el'
import LocaleEn from './../i18n/locale-en'
import Navbar from './navbar'
import Config from './config'
import Loading from './loading'

const CompLoading = props => {
  if (props.isLoading) {
    if (props.timedOut) {
      return null
    } else if (props.pastDelay) {
      return <div id='loading' />
    } else {
      return null
    }
  } else if (props.error) {
    return null
  } else {
    return null
  }
}

const LoadableData = Loadable({
  loader: () => import(/* webpackChunkName: "data" */ './data'),
  loading: CompLoading,
  timeout: 10000,
  delay: 500
})

const LoadableRequests = Loadable({
  loader: () => import(/* webpackChunkName: "requests" */ './requests'),
  loading: CompLoading,
  timeout: 10000,
  delay: 500
})

const LoadableRoles = Loadable({
  loader: () => import(/* webpackChunkName: "roles" */ './roles'),
  loading: CompLoading,
  timeout: 10000,
  delay: 500
})

const LoadableUsers = Loadable({
  loader: () => import(/* webpackChunkName: "users" */ './users'),
  loading: CompLoading,
  timeout: 10000,
  delay: 500
})

const LoadableRequestList = Loadable({
  loader: () => import(/* webpackChunkName: "requestList" */ './request-list'),
  loading: CompLoading,
  timeout: 10000,
  delay: 500
})

const LoadableRequestView = Loadable({
  loader: () => import(/* webpackChunkName: "requestView" */ './request-view'),
  loading: CompLoading,
  timeout: 10000,
  delay: 500
})

let BASE_URL = '/nlg-api'
let BASE_URL_CONFIG = BASE_URL
if (process.env.NODE_ENV !== 'production') {
  if (Config.baseUrl) {
    BASE_URL = Config.baseUrl
  }
  if (Config.baseUrlConfig) {
    BASE_URL_CONFIG = Config.baseUrlConfig
  }
}

const URL = {
  advancedSearchInfo: BASE_URL + '/account/admin/advanced-search-info',
  allocateRole: BASE_URL + '/account/admin/allocate-roles',
  answerRequest: BASE_URL + '/account/admin/answer-request',
  basicData: BASE_URL + '/account/get-data',
  config: BASE_URL_CONFIG + '/config-params',
  findUsers: BASE_URL + '/account/admin/find-users',
  gsisLogin: BASE_URL + '/account/gsis/login',
  gsisLogout: BASE_URL + '/account/gsis/logout',
  hrmsFieldValues: BASE_URL_CONFIG + '/hrms-field-values',
  idikaNotification: BASE_URL + '/account/idika-notification',
  idikaUpdate: BASE_URL + '/account/admin/update-ssn-data',
  login: BASE_URL + '/account/login-user',
  logout: BASE_URL + '/account/logout',
  password: '//mypassword.nlg.gr/',
  prefixList: BASE_URL_CONFIG + '/country-codes',
  privacyPolicy: '/policy',
  register: '//register.nlg.gr/',
  requestInfo: BASE_URL + '/account/admin/request-info',
  reviewableRoles: BASE_URL + '/account/admin/reviewable-roles',
  roles: BASE_URL + '/account/roles',
  roleHistory: BASE_URL + '/account/role-history',
  roleRequest: BASE_URL + '/account/role-request',
  roleRequests: BASE_URL + '/account/admin/role-requests',
  updateBasicData: BASE_URL + '/account/update-info',
  updateInternalPhone: BASE_URL + '/account/update-internal-phone',
  updateMail: BASE_URL + '/account/update-mail',
  updatePhone: BASE_URL + '/account/update-phone',
  upgrade: BASE_URL + '/account/admin/help-desk/foreign-certified',
  userData: BASE_URL + '/account/admin/user-data',
  userRequests: BASE_URL + '/account/admin/user-requests',
  userRoles: BASE_URL + '/account/admin/user-roles',
  verifyMail: BASE_URL + '/account/receive-mail-pin',
  verifyPhone: BASE_URL + '/account/receive-phone-pin',
  verifySsn: BASE_URL + '/account/gsis/validate-ssn',
  viewableRoles: BASE_URL + '/account/admin/viewable-roles'
}

const POLYGLOT = {
  el: new Polyglot({ phrases: LocaleEl, locale: 'el' }),
  en: new Polyglot({ phrases: LocaleEn, locale: 'en' })
}

const VALID_PATHS = {
  user: ['/data', '/roles', '/requests'],
  certified: ['/data', '/roles', '/requests'],
  staff: ['/data', '/roles', '/requests']
}

const ADMIN_PATHS = ['/users', '/respond']

const PRADO = {
  id: 'PRADO-B',
  militaryId: 'PRADO-B-F',
  passport: 'PRADO-A',
  birthPaper: 'PRADO-P-B'
}

const getCommonPrefix = (prefixList, prefix, phone) => {
  let common = prefix
  for (let i = phone.length; i >= 0; --i) {
    if (prefixList.find(v => '+' + v.prefix === prefix + phone.substr(0, i))) {
      common += phone.substr(0, i)
      break
    }
  }
  return common
}

const getLang = () => {
  let ret = 'el'
  const navLang = window.navigator.language.substr(0, 2)
  if (Object.keys(POLYGLOT).includes(window.localStorage.getItem('lang'))) {
    ret = window.localStorage.getItem('lang')
  } else if (Object.keys(POLYGLOT).includes(navLang)) {
    ret = navLang
  }
  return ret
}

class Index extends React.Component {
  state = {
    backendVersion: '0.0.0',

    warning: '',

    error: false,
    errorPage: false,
    lang: getLang(),
    loading: 0,
    top: false,

    ageMax: 150,
    ageMin: 13,
    pinLen: 6,

    prefixList: [],

    type: '',
    firstname: '',
    lastname: '',
    tin: '',
    ssn: '',
    birthDay: '',
    birthMonth: '',
    birthYear: '',
    mail: '',
    prefix: '',
    phone: '',
    internalPhone: '',
    cardID: '',

    idDoc: '',
    idCountry: '',
    idNumber: '',

    entitlement: '',

    idikaUpdate: false,
    updatedAt: '',

    isAdmin: '',
    isHelpDesk: ''
  }

  constructor (props) {
    super(props)
    document.title = POLYGLOT[this.state.lang].t('title')
  }

  componentWillMount = async () => {
    this.handleLoading(true)
    try {
      let r = await window.fetch(URL.config)
      r = await this.checkStatus(r)
      const res = await r.json()
      switch (res.error) {
        case undefined:
          this.setState({ backendVersion: res.version || '0.0.0' })
          if (
            this.state.ageMax !== res.userMaxAge ||
            this.state.ageMin !== res.userMinAge ||
            this.state.pinLen !== res.pinLen
          ) {
            this.setState({
              ageMax: res.userMaxAge,
              ageMin: res.userMinAge,
              pinLen: res.pinLen
            })
          }
          break
        default:
          this.handleError(true, res.error)
          break
      }
    } catch (e) {
      if (!e.res || e.res.status !== 401) {
        this.handleLoading(false)
        this.handleError(true)
      }
    }

    this.handleLoading(true)
    try {
      let r = await window.fetch(URL.prefixList)
      r = await this.checkStatus(r)
      const res = await r.json()
      switch (res.error) {
        case undefined:
          this.getData(res.countryCodes)
          break
        default:
          this.handleError(true, res.error)
      }
    } catch (e) {
      if (!e.res || e.res.status !== 401) {
        this.handleLoading(false)
        this.handleError(true)
      }
    }

    window.addEventListener('storage', this.handleStorage)
  }

  componentWillUnmount = () => {
    window.removeEventListener('storage', this.handleStorage)
  }

  componentWillUpdate = (nextProps, nextState) => {
    if (nextState.lang !== this.state.lang) {
      document.title = POLYGLOT[nextState.lang].t('title')
    }
  }

  checkStatus = res => {
    this.handleLoading(false)
    if (res.status >= 200 && res.status < 300) {
      return res
    }

    if (res.status === 401) {
      if (this.state.type) {
        this.setState({ type: '' })
      }
    }

    const error = new Error(res.statusText)
    error.res = res
    throw error
  }

  getData = async prefixList => {
    if (typeof prefixList === 'undefined') {
      prefixList = this.state.prefixList
    } else {
      prefixList.sort((a, b) =>
        a.name[this.state.lang].localeCompare(
          b.name[this.state.lang],
          this.state.lang,
          { sensitivity: 'base' }
        )
      )
    }

    this.handleLoading(true)
    try {
      let r = await window.fetch(URL.basicData, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: 'include'
      })
      r = await this.checkStatus(r)
      const res = await r.json()
      switch (res.error) {
        case undefined:
          if (res.updated) {
            this.setState({
              idikaUpdate: true,
              updatedAt: res.updatedAt
            })
          }

          const birthDate = (res.birthDate || '--').split('-')
          const prefix = getCommonPrefix(prefixList, '', res.phone || '')

          if (
            this.state.prefixList !== prefixList ||
            this.state.type !== res.primaryAffiliation ||
            this.state.firstname !== res.firstName ||
            this.state.lastname !== res.lastName ||
            this.state.tin !== res.tin ||
            this.state.tinCountry !== res.tinCountry ||
            this.state.ssn !== res.ssn ||
            this.state.ssnCountry !== res.ssnCountry ||
            this.state.birthDay !== birthDate[2] ||
            this.state.birthMonth !== birthDate[1] ||
            this.state.birthYear !== birthDate[0] ||
            this.state.mail !== res.email ||
            this.state.prefix !== prefix ||
            this.state.phone !== (res.phone || '').substr(prefix.length) ||
            this.state.internalPhone !== res.internalPhone ||
            this.state.cardID !== res.cardID
          ) {
            this.setState({
              prefixList,
              type: res.primaryAffiliation,
              firstname: res.firstName,
              lastname: res.lastName,
              tin: res.tin || '',
              tinCountry: res.tinCountry || '',
              ssn: res.ssn || '',
              ssnCountry: res.ssnCountry || '',
              birthDay: birthDate[2] || '',
              birthMonth: birthDate[1] || '',
              birthYear: birthDate[0] || '',
              mail: res.email || '',
              prefix,
              phone: (res.phone || '').substr(prefix.length),
              idDoc: res.documentType || '',
              idCountry: res.documentIssuingCountry || '',
              idNumber: res.documentId || '',
              internalPhone: res.internalPhone,
              cardID: res.cardID || ''
            })
            if (res.personEntitlement) {
              this.setState({
                entitlement: Array.isArray(JSON.parse(res.personEntitlement))
                  ? JSON.parse(res.personEntitlement)
                  : [parseInt(res.personEntitlement)]
              })
            } else {
              this.setState({
                entitlement: []
              })
            }

            this.setState({ isAdmin: res.isAdmin, isHelpDesk: res.isHelpDesk })
          }
          break

        default:
          this.handleError(true, res.error)
          break
      }
    } catch (e) {
      if (!e.res || e.res.status !== 401) {
        this.handleLoading(false)
        this.handleError(true)
      }
    }
  }

  handleError = (errorPage, error) => {
    if (typeof error === 'undefined') {
      error = this.state.error
    }
    if (this.state.errorPage !== errorPage || this.state.error !== error) {
      this.setState({ errorPage, error })
    }
  }

  handleLang = lang => {
    if (window.localStorage.getItem('lang') !== lang) {
      window.localStorage.setItem('lang', lang)
    }
    if (this.state.lang !== lang) {
      this.setState(prevState => ({
        lang,
        prefixList: prevState.prefixList.sort((a, b) =>
          a.name[lang].localeCompare(b.name[lang], lang, {
            sensitivity: 'base'
          })
        )
      }))
    }
  }

  handleLoading = loading => {
    this.setState(prevState => ({
      loading: prevState.loading + (loading ? 1 : -1)
    }))
  }

  handleStorage = e => {
    if (e.key === 'lang' && ['el', 'en'].includes(e.newValue)) {
      this.handleLang(e.newValue)
    }
  }

  handleIdikaNotification = () => {
    this.setState({ idikaUpdate: false })
  }

  render = () => (
    <Router>
      <div
        id='container_nlg'
        className={
          this.state.errorPage || this.state.error
            ? 'error'
            : this.state.warning ? 'redirect' : ''
        }
      >
        {this.state.loading > 0 && <Loading delay={500} />}
        <Route
          render={({ location }) => (
            <Header
              warning={this.state.warning}
              handleError={this.handleError}
              location={location}
              polyglot={POLYGLOT[this.state.lang]}
              validPaths={VALID_PATHS}
              url={URL}
              type={this.state.type}
              firstname={this.state.firstname}
              lastname={this.state.lastname}
            />
          )}
        />

        <div id='content' className='away_from_logo'>
          <Route
            render={({ location }) =>
              this.state.type === '' || this.state.errorPage ? null : (
                <Navbar
                  location={location}
                  polyglot={POLYGLOT[this.state.lang]}
                  validPaths={VALID_PATHS}
                  adminPaths={ADMIN_PATHS}
                  isAdmin={this.state.isAdmin}
                  type={this.state.type}
                />
              )}
          />

          <div className='tabs_content'>
            <Switch>
              <Route
                path={this.state.errorPage ? null : '/error'}
                render={({ history }) => (
                  <ErrorPage
                    handleError={this.handleError}
                    history={history}
                    polyglot={POLYGLOT[this.state.lang]}
                    url={URL}
                    error={this.state.error}
                  />
                )}
              />

              {this.state.type === '' && (
                <Route
                  render={() => (
                    <Auth polyglot={POLYGLOT[this.state.lang]} url={URL} />
                  )}
                />
              )}
              <Route
                path='/requests'
                render={() => (
                  <LoadableRequests
                    polyglot={POLYGLOT[this.state.lang]}
                    url={URL}
                    handleError={this.handleError}
                    handleLoading={this.handleLoading}
                    checkStatus={this.checkStatus}
                  />
                )}
              />
              <Route
                path='/roles'
                render={() => (
                  <LoadableRoles
                    polyglot={POLYGLOT[this.state.lang]}
                    url={URL}
                    handleError={this.handleError}
                    handleLoading={this.handleLoading}
                    checkStatus={this.checkStatus}
                  />
                )}
              />
              {this.state.isAdmin && (
                <Route
                  path='/users'
                  render={history => (
                    <LoadableUsers
                      countryCodes={this.state.prefixList}
                      polyglot={POLYGLOT[this.state.lang]}
                      handleLoading={this.handleLoading}
                      checkStatus={this.checkStatus}
                      handleError={this.handleError}
                      url={URL}
                      history={history}
                      prado={PRADO}
                      helpdesk={this.state.isHelpDesk}
                    />
                  )}
                />
              )}
              {this.state.isAdmin && (
                <Route path='/respond'>
                  <Switch>
                    <Route
                      path='/respond/:reqid'
                      render={props => (
                        <LoadableRequestView
                          history={props.history}
                          id={props.match.params.reqid}
                          checkStatus={this.checkStatus}
                          handleError={this.handleError}
                          handleLoading={this.handleLoading}
                          polyglot={POLYGLOT[this.state.lang]}
                          url={URL}
                        />
                      )}
                    />
                    <Route
                      path='/respond'
                      render={props => (
                        <LoadableRequestList
                          history={props.history}
                          location={props.location}
                          checkStatus={this.checkStatus}
                          handleError={this.handleError}
                          handleLoading={this.handleLoading}
                          polyglot={POLYGLOT[this.state.lang]}
                          url={URL}
                        />
                      )}
                    />
                  </Switch>
                </Route>
              )}
              <Route
                path='/data'
                render={({ history }) => (
                  <LoadableData
                    idikaUpdate={this.state.idikaUpdate}
                    updatedAt={this.state.updatedAt}
                    handleIdikaNotification={this.handleIdikaNotification}
                    checkStatus={this.checkStatus}
                    getData={this.getData}
                    getCommonPrefix={getCommonPrefix}
                    handleError={this.handleError}
                    handleLoading={this.handleLoading}
                    history={history}
                    polyglot={POLYGLOT[this.state.lang]}
                    url={URL}
                    ageMax={this.state.ageMax}
                    ageMin={this.state.ageMin}
                    pinLen={this.state.pinLen}
                    prefixList={this.state.prefixList}
                    type={this.state.type}
                    firstname={this.state.firstname}
                    lastname={this.state.lastname}
                    tin={this.state.tin}
                    tinCountry={this.state.tinCountry}
                    ssn={this.state.ssn}
                    ssnCountry={this.state.ssnCountry}
                    birthDay={this.state.birthDay}
                    birthMonth={this.state.birthMonth}
                    birthYear={this.state.birthYear}
                    mail={this.state.mail}
                    prefix={this.state.prefix}
                    phone={this.state.phone}
                    idNumber={this.state.idNumber}
                    idDoc={this.state.idDoc}
                    idCountry={this.state.idCountry}
                    internalPhone={this.state.internalPhone}
                    cardID={this.state.cardID}
                    prado={PRADO}
                  />
                )}
              />
              {this.state.isAdmin !== '' && <Redirect to='/data' />}
            </Switch>
          </div>

          <br className='clear' />
        </div>

        <Footer
          backendVersion={this.state.backendVersion}
          url={URL}
          handleLang={this.handleLang}
          polyglot={POLYGLOT[this.state.lang]}
        />
      </div>
    </Router>
  )
}

ReactDOM.render(<Index />, document.getElementById('root'))

export default Index



// WEBPACK FOOTER //
// ./src/index.js